import { render, staticRenderFns } from "./b2b.vue?vue&type=template&id=96508824&"
import script from "./b2b.vue?vue&type=script&lang=js&"
export * from "./b2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96508824')) {
      api.createRecord('96508824', component.options)
    } else {
      api.reload('96508824', component.options)
    }
    module.hot.accept("./b2b.vue?vue&type=template&id=96508824&", function () {
      api.rerender('96508824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Price/b2b.vue"
export default component.exports